import React, { useEffect, useState } from "react";
import "./style.scss";
import customStyles from "../../customStyles";
import Select from "react-select";
import contestantsIcon from "../../assets/icons/contestant_icon_white.svg";
import firstIcon from "../../assets/icons/firstPrize.svg";
import secondIcon from "../../assets/icons/secondPrize.svg";
import thirdIcon from "../../assets/icons/thirdPrize.svg";
import endDateIcon from "../../assets/icons/endDate_icon_white.svg";
import timeLeftIcon from "../../assets/icons/time_icon_white.svg";
import crossIcon from "../../assets/icons/cross_icon_white.svg";
import { ReactComponent as Qicon } from "../../assets/icons/qicons.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { competition } from "../../utils/store/reducers/competitionSlice";
import moment from "moment/moment";
import { enterCompetition } from "../../utils/apis/competition";
import { createFormData } from "../../utils/helpers/string";
import { returnMessages } from "../../utils/store/reducers/Message";
import { returnErrors } from "../../utils/store/reducers/Error";
import Spinner from "../../reusableComponents/spinner/Spinner";
import LoaderOverlay from "../../reusableComponents/LoaderOverlay/Index";
const Competition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { idToken } = useSelector((state) => state.auth);
  const { data, isLoading } = useSelector((state) => state.competitionList);
  useEffect(() => {
    dispatch(competition(idToken));
  }, [idToken]);
  const [competitionLists, setCompetitionLists] = useState([]);
  useEffect(() => {
    setCompetitionLists([
      ...(data?.Upcoming ?? []),
      ...(data?.Ongoing ?? []),
      ...(data?.End ?? []),
      ...(data?.Participated ?? []),
    ]);
  }, [data]);

  const options = [
    { value: "ALL", label: "ALL" },
    { value: "Upcoming", label: "Upcoming" },
    { value: "Ongoing", label: "Ongoing" },
    { value: "Participated", label: "Participated" },
    { value: "End", label: "Ended" },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    if (selectedOption.value === "ALL") {
      setCompetitionLists([
        ...data.Upcoming,
        ...data.Ongoing,
        ...data.End,
        ...data.Participated,
      ]);
    } else {
      setCompetitionLists(data[selectedOption?.value]);
    }
  };

  const [isRulesVisible, setIsRulesVisible] = useState(false);

  const CompetitionData = ({ item, index }) => {
    const [timeRemaining, setTimeRemaining] = useState(
      moment.utc(item.close_entry_on, "DD-MM-YYYY").diff(moment.utc(), "milliseconds")
    );
  
    useEffect(() => {
      const calculateTimeRemaining = () =>
        moment.utc(item.close_entry_on, "DD-MM-YYYY").diff(moment.utc(), "milliseconds");
  
      const timerInterval = setInterval(() => {
        const remaining = calculateTimeRemaining();
        setTimeRemaining(remaining > 0 ? remaining : 0);
      }, 1000);
  
      return () => clearInterval(timerInterval);
    }, [item.close_entry_on]);

    const duration = moment.duration(timeRemaining);
    const days = String(duration.days()).padStart(2, "0");
    const hours = String(duration.hours()).padStart(2, "0");
    const minutes = String(duration.minutes()).padStart(2, "0");
    const seconds = String(duration.seconds()).padStart(2, "0");
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleEnterCompetition = async (e) => {
      try {
        setIsSubmitting(true);
        const data = {
          competition: e.id,
          account_type: "demo",
          platform: 1,
        };
        const formdata = createFormData(data);
        const response = await enterCompetition(formdata, idToken);
                if (response.status < 399) {
          dispatch(returnMessages(response.data.detail, 200));
          dispatch(competition(idToken));
          setIsSubmitting(false);
        }
      } catch (error) {
                dispatch(returnErrors(error.response.data.detail, 200));
        setIsSubmitting(false);
      }
    };
    return (
      <div className="compData_container" key={index}>
        <div className="compData_wrapper">
          <div className="status_btns">
            <div
              className={`comp_status ${
                item.status === "Participated" || item.status === "End"
                  ? "red_status"
                  : item.status === "Upcoming"
                  ? "yellow_status"
                  : "green_status"
              }`}
            >
              <p>{item.status}</p>
            </div>
            <div className="view_btn">
              <Qicon />
              View Rules
            </div>
          </div>
          <div className="midSection">
            <div className="header_container">
              <h2>{item.name}</h2>
              <p>{item.prize_money}in prizes</p>
            </div>
            <div className="comp_details">
              <div className="contestants_box comp_details_box">
                <img src={contestantsIcon} alt="" />
                <p>
                  {item.participated_contestants}/{item.total_contestants}{" "}
                  contestants
                </p>
              </div>
              {/* <div className="contestants_box comp_details_box">
                <img src={contestantsIcon} alt="" />
                <p>Total contestants {item.total_contestants}</p>
              </div> */}
              <div className="end_date_box comp_details_box">
                <img src={endDateIcon} alt="" />
                <p>
                  <span>End Date:</span> {item.end_Date}
                </p>
              </div>
              <div className="time_left_box comp_details_box">
                <img src={timeLeftIcon} alt="" />
                <p>{`${days}d : ${hours}h : ${minutes}m : ${seconds}s left`}</p>
              </div>
            </div>
            <div className="comp_details">
              <div className="contestants_box comp_details_box">
                <p className="ranks">1</p>
                <img src={firstIcon} alt="" />
                <p>{item?.first_prize}</p>
              </div>
              <div className="end_date_box comp_details_box">
                <p className="ranks">2</p>
                <img src={secondIcon} alt="" />
                <p>{item?.second_prize}</p>
              </div>
              <div className="time_left_box comp_details_box">
                <p className="ranks">3</p>
                <img style={{ paddingLeft: "8px" }} src={thirdIcon} alt="" />
                <p>{item?.third_prize}</p>
              </div>
            </div>
          </div>
          <div className="button_container">
            <button
              className="rules_button "
              onClick={() => {
                setrulesList(item.rules);
                setIsRulesVisible(!isRulesVisible);
              }}
            >
              View Rules
            </button>
            {item.participated === true ? (
              <Link
                to={`/competition/${item.id}`}
                state={item}
                style={{ textDecoration: "none", width: "100%" }}
              >
                <button className="view_more standard-button">
                  See Leaderboard
                </button>
              </Link>
            ) : (
              <Link
                onClick={() => handleEnterCompetition(item)}
                style={{ textDecoration: "none", width: "100%" }}
              >
                <button className="view_more standard-button">
                  {isSubmitting ? <Spinner /> : "Enter Competition"}
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  };

  const [rulesList, setrulesList] = useState();

  return (
    <>
      <div className="competition_container">
        {isLoading === true && <LoaderOverlay />}

        <div className="competition_filter_wrapper">
          <Select
            value={selectedOption}
            isSearchable={false}
            onChange={handleChange}
            options={options}
            styles={customStyles}
          />
        </div>
        <div className="competition_wrapper">
          {competitionLists?.map((item, index) => (
            <CompetitionData key={item.id} item={item} index={index} />
          ))}
        </div>
      </div>
      {isRulesVisible ? (
        <div className="rulesModal">
          <div
            className="rules_overlay"
            onClick={() => {
              setIsRulesVisible(false);
            }}
          >
            <div
              className="competition_rules_container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="competition_rules_wrapper">
                <div className="header_container">
                  <div className="close_button">
                    <img
                      src={crossIcon}
                      alt=""
                      onClick={() => {
                        setIsRulesVisible(false);
                      }}
                    />
                  </div>
                  <h2>Rules for March Competition</h2>
                  <p>
                    The Following Rules apply to the competition. Please Read
                    The Carefully before registering.
                  </p>
                </div>
                <div className="rules_container">
                  <ul className="rules_list">
                    {/* {rulesList.map((rule) => ( */}
                    <li className="list_items">{rulesList}</li>
                    {/* ))} */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Competition;
